import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

// Cache-busting of the translation files: the main bundle name carries a hash that changes on
// every build, so a new deployment always fetches fresh JSON even from a browser that cached the
// previous files (the dev server has no hashed bundle: fixed version).
const buildId = Array.from(document.scripts)
  .map((script) => script.src.match(/main\.([0-9a-f]+)\.js/)?.[1])
  .find(Boolean);
const version = buildId ?? '1.0.15';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: false, // Activer ou désactiver les logs de débogage
    fallbackLng: 'en', // Si la langue n'est pas supportée, utiliser 'en'
    returnEmptyString: false,
    nsSeparator: ':',
    backend: {
      loadPath: `/locales/{{lng}}/{{ns}}.json?v=${version}`,
    },
    ns: [
      'common',
      'sidebar',
      'login',
      'forms',
      'clientArea',
      'components',
      'area',
      'withdraw',
      'passwordReset',
      'paymentModal',
      'buyFunded',
      'firstTimeBuyFunded',
      'transactionHistory',
      'switchRfx',
      'errors',
      'sso',
      'application',
      'cookies',
      'adminApplications',
      'maintenance'
    ],
    defaultNS: 'common',
    detection: {
      // Configurer la détection de langue
      order: ['localStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
      caches: ['localStorage'], // Cache la langue choisie dans localStorage
    },
    interpolation: {
      escapeValue: false, // React s'occupe déjà de l'échappement
    },
    supportedLngs: ['en', 'fr', 'es', 'ar'], // Liste des langues supportées
  });

export default i18n;
